import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
// import { Github, Linkedin, Twitter } from 'lucide-react';

const footerLinks = {
  company: [
    { name: 'About', path: '/about' },
    { name: 'Portfolio', path: '/portfolio' },
    { name: 'Blog', path: '/blog' },
    { name: 'Contact', path: '/contact' },
  ],
  services: [
    { name: 'Website Design' },
    { name: 'IT Support' },
    { name: 'IT Consulting' },
    { name: 'eCommerce' },
  ],
  legal: [
    { name: 'Privacy Policy', path: '/legal/privacy' },
    { name: 'Terms of Service', path: '/legal/terms' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-night-900 border-t border-night-600">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1">
            <motion.div
              className="text-2xl font-bold bg-gradient-to-r from-launch-blue via-launch-purple to-launch-orange bg-clip-text text-transparent mb-4"
              whileHover={{ scale: 1.05 }}
            >
              Cloud Launch
            </motion.div>
            <p className="text-offwhite/60 text-sm mb-4">
              Launch your business to the cloud with modern, custom technology.
            </p>
            <div className="space-y-2">
              <a 
                href="tel:+61721127733" 
                className="text-offwhite/60 hover:text-launch-purple transition-colors text-sm flex items-center gap-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                </svg>
                07 2112 7733
              </a>
              <a 
                href="mailto:hello@cloudlaunch.com" 
                className="text-offwhite/60 hover:text-launch-blue transition-colors text-sm flex items-center gap-2"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
                  <path d="M22 6l-10 7L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                hello@cloudlaunch.com
              </a>
            </div>
            {/* Social media links - commented out until social media is ready
            <div className="flex space-x-4 mt-4">
              <a href="#" className="text-offwhite/60 hover:text-launch-blue transition-colors">
                <Github size={20} />
              </a>
              <a href="#" className="text-offwhite/60 hover:text-launch-blue transition-colors">
                <Linkedin size={20} />
              </a>
              <a href="#" className="text-offwhite/60 hover:text-launch-blue transition-colors">
                <Twitter size={20} />
              </a>
            </div>
            */}
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-offwhite font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              {footerLinks.company.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-offwhite/60 hover:text-launch-blue transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Links */}
          <div>
            <h3 className="text-offwhite font-semibold mb-4">Services</h3>
            <ul className="space-y-2">
              {footerLinks.services.map((link) => (
                <li key={link.name}>
                  <span className="text-offwhite/60 text-sm">
                    {link.name}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-offwhite font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              {footerLinks.legal.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-offwhite/60 hover:text-launch-blue transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-night-600 text-center">
          <p className="text-offwhite/40 text-sm">
            © {new Date().getFullYear()} Cloud Launch. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
